<template>
  <v-main class="background">
      <v-navigation-drawer
        v-model="drawer"
        app
        mobile-breakpoint="1025"
        class="elevation-0 border-none"
        floating
        >
          <v-list-item class="my-2">
            <v-list-item-avatar size="50">
              <v-img src="../../assets/fiemslogo.png"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title primary--text font-weight-bold py-1" >
                FIEMS
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list dense nav>
            <v-list-item
              v-for="item in items"
              :key="item.title"
              router :to="item.route"
              active-class="primary--text"
            >
              <v-list-item-icon>
                <v-icon class="font-weight-bold">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--///////-->
          </v-list>
        </v-navigation-drawer>
      <v-app-bar
        fixed
        app
        flat
        color="third"
      >
        <v-app-bar-nav-icon class="ml-2 primary--text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <div class="destop-view"><p class="ma-2 greetings-desktop primary--text">Hi Admin</p></div>
        <v-menu
          bottom
          left
          offset-y
          origin="top right"
        >
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              class="mr-1"
            >
              <v-avatar size="40">
                <img src="../../assets/fiemslogo.png">
              </v-avatar>
            </v-btn>
          </template>
          <v-list dense nav>
            <v-list-item
              v-for="item in navi"
              :key="item.title"
              router :to="item.route"
              active-class="primary--text"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-btn color="primary" block @click="logOut">
              <v-icon left class="pr-4">
                mdi-power
              </v-icon>
              Logout
            </v-btn>
          </v-list>
        </v-menu>
      </v-app-bar>
    <v-container fluid>
      <router-view></router-view>
      <bottomfooter></bottomfooter>
    </v-container>
  </v-main>
</template>

<script>
import bottomfooter from '@/components/core/BottomFooter'

export default {
  name: 'appbar',
  components: {
    bottomfooter
  },
  data () {
    return {
      drawer: null,
      items: [
        {
          icon: 'mdi-television',
          title: 'Dashboard',
          route: '/'
        },
        {
          icon: 'mdi-table',
          title: 'Farmerstable',
          route: '/akfimsfarmers'
        },
        {
          icon: 'mdi-table',
          title: 'Enumeratorstable',
          route: '/enumeratorstable'
        },
        {
          icon: 'mdi-account-group',
          title: 'Enumerator',
          route: '/enumerator'
        }
      ],
      navi: [
        {
          icon: 'mdi-television',
          title: 'Dashboard',
          route: '/'
        }
      ]
    }
  },
  methods: {
    async logOut () {
      this.$store.dispatch('logoutAdmin')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.greetings-desktop{
  font-family:inherit;
  font-style: normal;
  font-weight: 800;
  font-size: 25px;
  line-height: 29px;
  color: #0D8134;
}
.greetings-mobile{
  font-family:inherit;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #0D8134;
}
</style>
